import React from 'react';
import { formatDecimal } from 'lib/helpers/strings';
import { Link } from 'modules/i18n';
import { RatingCriterionRow } from './RatingCriterionRow';

type RatingBreakdownTooltipProps = {
  average: number;
  count: number;
  responsiveness: number;
  relevance: number;
  reliability: number;
  userId: string;
};

export function RatingBreakdownTooltip({
  average,
  count,
  responsiveness,
  relevance,
  reliability,
  userId,
}: RatingBreakdownTooltipProps) {
  return (
    <div className="space-y-2 p-3 bg-white rounded-lg shadow-lg border border-gray-200 max-w-xs">
      <div className="font-semibold text-sm">
        Note moyenne : {formatDecimal(average)}/5 ({count} avis)
      </div>
      <div className="space-y-1.5 text-xs">
        <RatingCriterionRow label="Réactivité" value={responsiveness} />
        <RatingCriterionRow label="Pertinence" value={relevance} />
        <RatingCriterionRow label="Paiement" value={reliability} />
      </div>
      <div className="pt-2 border-t border-gray-200">
        <Link href={`/members?displayMode=table&sectorIds=&occupationIds=&countryIds=&_id=${userId}`} className="text-xs text-primary hover:underline">
          Voir tous les avis ({count})
        </Link>
      </div>
    </div>
  );
}
